// Persistenter Zustand fuer den laufenden QM-Handbuch-Export. Liegt in
// localStorage, damit die "Export fertig"-Benachrichtigung Seitenwechsel und
// Neuladen uebersteht (der eigentliche Status liegt im Backend). Der
// QmExportWatcher (app-weit gemountet) liest diesen Zustand und pollt.
const KEY = "sonne_qm_export_pending_v1";

export type PendingQmExport = { exportId: number; businessId: string; startedAt: number };

export function setPendingQmExport(pending: PendingQmExport): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(pending));
  } catch {
    /* localStorage nicht verfuegbar – ignorieren */
  }
  window.dispatchEvent(new CustomEvent("qm-export:changed"));
}

export function getPendingQmExport(): PendingQmExport | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PendingQmExport;
    if (typeof parsed?.exportId === "number" && typeof parsed?.businessId === "string" && parsed.businessId) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}

export function clearPendingQmExport(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignorieren */
  }
  window.dispatchEvent(new CustomEvent("qm-export:changed"));
}
